import { useState, useEffect } from "react";

const useForm = (callback) => {
  const [formData, setFormData] = useState({
    firstName: "",
    email: "",
    phone: "",
    instagram: "",
    linkedin: "",
    preferredContact: "",
    communityInterest: "",
  });
  const [message, setMessage] = useState(""); // state of the user message 
  const [isLoading, setIsLoading] = useState(false); // loading state

  useEffect(() => {}, [message]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.phone) {
      setMessage("❌ Please enter a valid phone number.");
      return;
    }    
    
    setIsLoading(true); // Activar loader
    setMessage(""); // Limpiar mensaje anterior

    try {
      const contactResponse = await fetch("/api/saveContact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ formData }),
      });

      if (!contactResponse.ok) {
        const errorData = await contactResponse.json();
        if (errorData.message === "This email is already registered in the waitlist") {
          setMessage("❌ This email is already registered. Please use a different email address.");
          return;
        }
        throw new Error(errorData.error || "Error al guardar el contacto");
      }

      // Check if there's a referral code in the URL
      const urlParams = new URLSearchParams(window.location.search);
      const referralCode = urlParams.get('ref');
      if (referralCode) {
        // Validate UUID format
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        
        if (uuidRegex.test(referralCode)) {
          // Send to waitlist with referral
          const waitlistResponse = await fetch("/api/referralWaitlist", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              email: formData.email,
              name: formData.firstName,
              phone: formData.phone,
              partner_url: referralCode
            }),
          });

          await waitlistResponse.json();
          if (!waitlistResponse.ok) {
            const errorData = await waitlistResponse.json();
            console.error("Referral waitlist error:", errorData);
            if (errorData.message === "This email has already been referred by this partner") {
              setMessage("⚠️ You've been successfully added to the waitlist, but this email is already registered with a referral from this partner.");
              return;
            }
          }
        } else {
          console.warn("Invalid referral code format:", referralCode);
        }
      }

      // Enviar email de bienvenida
      await fetch("/api/welcome", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formData.firstName,
          email: formData.email,
        }),
      });

      // Personalizar mensaje según si había referral
      let successMessage = "✅ Thank you for joining our community!\n\nEnjoy the Slowork experience.";
      
      if (referralCode) {
        successMessage = "✅ Thank you for joining our community through a referral!\n\nYou and your referrer are now part of the Slowork family. Enjoy the experience!";
      }

      setMessage(successMessage);

      setFormData({
        firstName: "",
        email: "",
        phone: "",
        instagram: "",
        linkedin: "",
        preferredContact: "",
        communityInterest: "",
      });
    } catch (error) {
      console.error("❌ Unexpected error:", error);
      setMessage("❌ Oops! An unexpected error occurred. Please try again.");
    } finally {
      setIsLoading(false); // Desactivar loader
    }
  };


  return { formData, handleChange, handleSubmit, message, isLoading };
};

export default useForm;
